import { RESEND_INVITE_TOKEN } from '../Types';

/**
 * Resend an invite token
 *
 * @param {} email
 */
export const resendInviteToken = (email) => {
  return (dispatch) => {
    const action = {
      type: RESEND_INVITE_TOKEN,
      request: async (apiClient) => {
        const user = await apiClient.user.resendInviteToken(email);

        return user;
      },
      payload: email,
    };

    dispatch(action);
  };
};

export default resendInviteToken;
